import { Ref, inject, ref } from "vue";
import { NowInjectionKey } from "./useLiveTime";

export default function useNow () {
  const now = inject<Ref<Date>>(NowInjectionKey, ref(new Date));

  return {
    now,
  };
}
